var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "boss-main-container" }, [
    _c(
      "div",
      { staticClass: "boss-main-wrap boss-main-content-wrap" },
      [
        _c("setting-header", { attrs: { title: "一次面接候補日設定" } }),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("form-label", {
          attrs: {
            label: "一次面接候補日設定機能",
            "class-name": "boss-text margin-top-0",
            "is-required": "",
          },
          scopedSlots: _vm._u([
            {
              key: "body",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "pega-relative height-100" },
                    [
                      _vm._l(_vm.whetherToUses, function (whetherToUse, i) {
                        return _c("div", { key: i }, [
                          _c(
                            "label",
                            { staticClass: "pega-badge-radio pega-mr-5" },
                            [
                              _c("input", {
                                attrs: {
                                  type: "radio",
                                  "data-test": "use-setting-radio" + i,
                                },
                                domProps: {
                                  value: whetherToUse.value,
                                  checked:
                                    _vm.isUseSetting === whetherToUse.value,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.updateIsUseSetting(
                                      whetherToUse.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "pega-badge-radio-text pega-badge-radio-check-mark",
                                  attrs: {
                                    "data-test": "use-setting-label" + i,
                                  },
                                },
                                [_vm._v(_vm._s(whetherToUse.label))]
                              ),
                            ]
                          ),
                        ])
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "pega-annotation-text-padding width-100",
                        },
                        [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "/help/guide/index_274.html",
                                "data-test": "use-setting-about-link",
                                target: "_blank",
                              },
                            },
                            [
                              _vm._v(
                                "\n              一次面接候補日設定機能とは？\n            "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    2
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        }),
        _vm._v(" "),
        _vm.isUseSetting
          ? _c(
              "div",
              { attrs: { "data-test": "schedule-list" } },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "boss-joboffer-title boss-setting margin-top-1",
                    attrs: { "data-test": "candidate-date-title" },
                  },
                  [_vm._v("\n        求人設定\n      ")]
                ),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _c("interview-candidate-date-jobs", {
                  attrs: { jobs: _vm.jobs, schedules: _vm.schedules },
                  on: { update: _vm.updateJobScheduleLinking },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "boss-joboffer-title boss-setting margin-top-1",
                  },
                  [_vm._v("\n        応募者への表示日程\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  { staticClass: "boss-text margin-top-0 margin-bottom-1" },
                  [
                    _vm._v(
                      "\n        応募者へ現在表示されている日程を確認できます。「編集する」から設定できます。\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("interview-candidate-date-schedules", {
                  staticClass: "boss-text margin-top-0",
                  attrs: { schedules: _vm.schedules, jobs: _vm.jobs },
                }),
              ],
              1
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "boss-text margin-top-0 margin-bottom-1" }, [
      _vm._v("\n      応募時に、一次面接の希望日をヒアリングする機能です。"),
      _c("br"),
      _vm._v(
        "\n      任意項目のため回答のない場合や、外部提携サイト経由の応募は機能が反映されない場合があります。\n    "
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      {
        staticClass: "boss-text margin-top-0 margin-bottom-1",
        attrs: { "data-test": "description" },
      },
      [
        _vm._v("\n        求人ごとに表示させるカレンダーを設定できます。"),
        _c("br"),
        _vm._v(
          "\n        ※掲載中、あるいは今後掲載予定の求人が表示されます。通常、掲載開始日の前日15時以降から設定可能です。\n      "
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }